/**
 * @desc 根据箱号批次号查询箱号列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierBox.getBoxCodeListByBoxCodeBatchNumber.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierBox/getBoxCodeListByBoxCodeBatchNumber`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
